/**
 * EligibilityBadge — tri-state status pill rendered on grant cards +
 * Grant Detail's above-the-fold snapshot. Never numeric — Match Score
 * is deferred to G2.
 */
import { CheckCircle2, HelpCircle, XCircle } from "lucide-react";

const STATUS_META = {
  eligible: {
    label: "Appears Eligible",
    color: "#0F9F70",
    tint: "rgba(52,211,153,0.14)",
    border: "rgba(52,211,153,0.45)",
    Icon: CheckCircle2,
  },
  potentially_eligible: {
    label: "Potentially Eligible",
    color: "#FBBF24",
    tint: "rgba(251,191,36,0.14)",
    border: "rgba(251,191,36,0.45)",
    Icon: HelpCircle,
  },
  not_currently_eligible: {
    label: "Not Currently Eligible",
    color: "#EF4444",
    tint: "rgba(239,68,68,0.14)",
    border: "rgba(239,68,68,0.45)",
    Icon: XCircle,
  },
};

export default function EligibilityBadge({ status, testId, size = "md" }) {
  const meta = STATUS_META[status] || STATUS_META.potentially_eligible;
  const Icon = meta.Icon;
  const padding = size === "lg" ? "px-4 py-2 text-sm" : "px-3 py-1.5 text-xs";
  return (
    <span
      data-testid={testId || `eligibility-badge-${status}`}
      className={`inline-flex items-center gap-2 rounded-full uppercase tracking-[0.14em] font-semibold ${padding}`}
      style={{
        background: meta.tint,
        border: `1px solid ${meta.border}`,
        color: meta.color,
      }}
    >
      <Icon className={size === "lg" ? "w-4 h-4" : "w-3.5 h-3.5"} />
      {meta.label}
    </span>
  );
}

export { STATUS_META };
